import React from 'react';
import { Navigate } from 'react-router-dom';
import { Shield, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useUserRole } from '../hooks/useUserRole';
import AppLayout from './layout/AppLayout';

interface RequireAdminProps {
  children: React.ReactNode;
}

export default function RequireAdmin({ children }: RequireAdminProps) {
  const { isAdmin, loading } = useUserRole();

  if (loading) {
    return (
      <AppLayout>
        <div className="flex items-center justify-center h-full">
          <div className="text-text-secondary">Loading...</div>
        </div>
      </AppLayout>
    );
  }

  if (!isAdmin) {
    return (
      <AppLayout>
        <div className="flex items-center justify-center h-full">
          <div className="text-center max-w-md">
            <Shield className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-text-primary mb-2">Access Restricted</h2>
            <p className="text-text-secondary mb-6">
              This page is only accessible to school administrators. Please contact your administrator if you need access.
            </p>
            <Link
              to="/settings"
              className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Settings
            </Link>
          </div>
        </div>
      </AppLayout>
    );
  }

  return <>{children}</>;
}